module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Hummer#2-4039e847c8a7786706af6f59b342404f.svg";